export enum ENUM__position_9 {
  BOTTOM_LEFT = 'bottom_left',
  BOTTOM_CENTER = 'bottom_center',
  BOTTOM_RIGHT = 'bottom_right',

  /*
   *
   */

  CENTER_LEFT = 'center_left',
  CENTER_CENTER = 'center_center',
  CENTER_RIGHT = 'center_right',

  /*
   *
   */

  TOP_LEFT = 'top_left',
  TOP_CENTER = 'top_center',
  TOP_RIGHT = 'top_right',
}

export namespace ENUM_UTILS__position_9 {
  export function to_css_1(value: ENUM__position_9) {
    return to_css(value, 1, 1);
  }

  export function to_css(value: ENUM__position_9, offset_x: number = 0, offset_y: number = 0) {
    let out_map = new Map<ENUM__position_9, string>([
      [ENUM__position_9.BOTTOM_LEFT, `bottom-${offset_y} left-${offset_x}`],
      [ENUM__position_9.BOTTOM_CENTER, `bottom-${offset_y} left-1/2 -translate-x-1/2 translate-x-${offset_x}`],
      [ENUM__position_9.BOTTOM_RIGHT, `bottom-${offset_y} right-${offset_x}`],

      [ENUM__position_9.CENTER_LEFT, `top-1/2 left-${offset_x} -translate-y-1/2 translate-y-${offset_y}`],
      [ENUM__position_9.CENTER_CENTER, `top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 translate-x-${offset_x} translate-y-${offset_y}`],
      [ENUM__position_9.CENTER_RIGHT, `top-1/2 right-${offset_x} -translate-y-1/2 translate-y-${offset_y}`],

      [ENUM__position_9.TOP_LEFT, `top-${offset_y} left-${offset_x}`],
      [ENUM__position_9.TOP_CENTER, `top-${offset_y} left-1/2 -translate-x-1/2 translate-x-${offset_x}`],
      [ENUM__position_9.TOP_RIGHT, `top-${offset_y} right-${offset_x}`],
    ]);

    let out = out_map.get_or_assert(value);

    return out;
  }
}
